const SPA_STEP_TO_RETURN_TO = 'availability';

const SPA_STEP_TO_LEAVE = 'extras';

let isReloadingAfterError = false;

export const isPageReloadingAfterError = () => isReloadingAfterError;

export const reloadAfterError = () => {
  isReloadingAfterError = true;
  window.location.reload();
};

export const resetAfterError = (preventPageReload: boolean) => {
  if (!preventPageReload) {
    reloadAfterError();
    return;
  }

  const { pathname } = window.location;
  if (pathname.includes('spa')) {
    window.location.href = pathname.replace(SPA_STEP_TO_LEAVE, SPA_STEP_TO_RETURN_TO);
  }
};
